import Switch from "@mui/material/Switch";
import { observer } from "mobx-react-lite";
import { CreatedWithin, ITenantInMarketFilterSettings } from "../../interfaces/IFilterSettings";
import styles from "./GlobalFilters.module.css";

function GlobalFiltersTenantsInMarketTab({ tenantInMarketFiltersState, setTenantInMarketFiltersState }: IGlobalFiltersTenantsInMarketTabProps) {
    return (
        <div className={styles.columns}>
            <div className={styles.column}>
                <label className={styles.label}>
                    CREATED WITHIN
                    <select className={styles.textInput} value={tenantInMarketFiltersState.createdWithin} onChange={e => setTenantInMarketFiltersState({
                        ...tenantInMarketFiltersState,
                        createdWithin: e.target.value as CreatedWithin,
                    })}>
                        <option value={CreatedWithin.Anytime}>Anytime</option>
                        <option value={CreatedWithin.OneMonth}>1 Month</option>
                        <option value={CreatedWithin.ThreeMonth}>3 Months</option>
                        <option value={CreatedWithin.SixMonth}>6 Months</option>
                        <option value={CreatedWithin.TwelveMonth}>12 Months</option>
                    </select>
                </label>
            </div>
            <div className={styles.column}>
                <div className={styles.switchesSection}>
                    DISPLAY OPTIONS
                    <div>
                        <label className={styles.switchRow}>
                            <span className={styles.switchLabel}>Show Inactive</span>
                            <Switch
                                checked={tenantInMarketFiltersState.showInactive}
                                onChange={e => setTenantInMarketFiltersState({
                                    ...tenantInMarketFiltersState,
                                    showInactive: e.target.checked,
                                })}
                            />
                        </label>
                        <label className={styles.switchRow}>
                            <span className={styles.switchLabel}>Show Lost Deals</span>
                            <Switch
                                checked={tenantInMarketFiltersState.showLostDeals}
                                onChange={e => setTenantInMarketFiltersState({
                                    ...tenantInMarketFiltersState,
                                    showLostDeals: e.target.checked,
                                })}
                            />
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default observer(GlobalFiltersTenantsInMarketTab);

interface IGlobalFiltersTenantsInMarketTabProps {
    tenantInMarketFiltersState: ITenantInMarketFilterSettings;
    setTenantInMarketFiltersState: (value: ITenantInMarketFilterSettings) => void;
}